import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { forwardRef, useImperativeHandle } from 'react';
import { DropdownListItem } from './list-item';
const b = bemClassBuilder('v-dropdown-group');
const DropdownGroupBase = (props, ref) => {
    const { label, options } = props;
    const listItemRefs = {};
    useImperativeHandle(ref, () => ({
        scrollOptionIntoView
    }));
    const scrollOptionIntoView = (value) => {
        var _a;
        (_a = listItemRefs[value]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    };
    if (isEmptyArray(options))
        return null;
    return (_jsxs(_Fragment, { children: [label && _jsx("li", Object.assign({ className: b.element('label') }, { children: label })), options.map(option => (_jsx(DropdownListItem, { option: option, ref: instance => (listItemRefs[option.value] = instance) }, option.value)))] }));
};
export const DropdownGroup = observer(forwardRef(DropdownGroupBase));
DropdownGroup.displayName = 'DropdownGroup';
